import React from 'react'
import { FormattedMessage } from 'react-intl';
import XIcon  from '../../assets/icons/close-icon.svg'
import "./DeleteModal.scss"
import { Button, EButtonType } from '../Button';

interface Props {
    history: any;
    close: () => void;
    deleteFunction?: () => void;
    children?: any
}

interface State {

}

class DeleteModalComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {

        }
    }

    render() {
        return (
            <div className="delete-modal">
                <div className="d-flex flex-column align-items-center w-75">
                    <p className="medium-text questionary-title">
                        <FormattedMessage id="common.confirm.title" defaultMessage="Are you sure?" />
                    </p>
                    <div className={'childrenContainer'}>
                        {this.props?.children}
                    </div>
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-5">
                                <Button onClick={this.props.close}
                                    submit={true}
                                    className="ml-0 col-12 align-items-center mb-3 px-3 text-center"
                                    buttonType={EButtonType.GreyButton}>
                                    <FormattedMessage id="common.confirm.no" defaultMessage="No" />
                                </Button>
                            </div>
                            <div className="col-5">
                                <Button
                                    onClick={() => this.props.deleteFunction()}
                                    submit={true}
                                    className="ml-0 col-12 align-items-center mb-3 px-3 text-center"
                                    buttonType={EButtonType.PurpleButton}>
                                    <FormattedMessage id="common.confirm.yes" defaultMessage="Yes" />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DeleteModalComponent
